export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./hdraces-bets.vue?vue&type=template&id=aee3c7aa&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/bets/hdraces-bets.vue?vue&type=template&id=aee3c7aa&scoped=true
// module id = HtDF
// module chunks = 0